import { render, staticRenderFns } from "./query-ranking-audit-item-details.component.vue?vue&type=template&id=40fc96e1&scoped=true"
import script from "./query-ranking-audit-item-details.component.vue?vue&type=script&lang=ts"
export * from "./query-ranking-audit-item-details.component.vue?vue&type=script&lang=ts"
import style0 from "./query-ranking-audit-item-details.component.vue?vue&type=style&index=0&id=40fc96e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc96e1",
  null
  
)

export default component.exports